import Constant from "../utils/constant";
const BASE_PATH_WEB = "/index.php?main_page=info_check&action=change_country_currency";

function getPathByRun(isUat: boolean) {
	// UAT需要配置host文件测试，线上把host文件去掉
	console.log("isUat", isUat)
	// const host = isUat ? "https://www.ouku.com" : "https://www.ouku.com";
	const host = "https://www.ouku.com";
	return `${host}${BASE_PATH_WEB}`;
}
export interface Options {
	cookie?: string;
	fetchMethod?: "GET" | "POST";
	isDev?: boolean;
	language?: string;
	countryCode?: string;
	currencyCode?: string;
}
function setSession<T>(params: Options): Promise<T> {
	const {
		fetchMethod = "GET",
		language = Constant.language,
		countryCode = Constant.countryCode2,
		currencyCode = Constant.currency
	} = params;
	const bashPath = getPathByRun(Constant.isUat);
	const url = `${bashPath}&language=${language}&country_code=${countryCode}&currency_code=${currencyCode}`;
	return fetch(url, {
		mode: "cors",
		method: fetchMethod,
		// credentials: Constant.isUat ? "same-origin" : "include"
		credentials: "include"
	}).then(response => {
		return response.json() as Promise<T>;
	});
}

export default setSession;
